import * as React from 'react';

const StartingInfoContext = React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  StartingInfoContext.displayName = 'StartingInfoContext';
}

export default StartingInfoContext;
